import { line, curveStepAfter, curveStepBefore, curveStep, CurveFactory } from "d3"
 

export type PathStyles = 'default' | 'dashed' | 'dotted' | 'spacer' | 'no-data' | string

export interface LineProps extends SVGPathElement {
  // this only applies to the "stroke" of the path, not the fill, to set the fill, use the "fill" prop of path_style
  color?: string;
  // this is either a string that corresponds to a predefined style in the component, or inline css styles that get applied to the path element
  path_style?: CSSStyleDeclaration | PathStyles,
  // this gets passed to stroke width
  size?: number;
  [key: string]: unknown
}

export interface D3LineProps extends LineProps {
  curve?: string | CurveFactory;
  scale_x?: Record<string, unknown>;
  scale_y?: Record<string, unknown>;
  data?: Record<string, unknown>[] | Record<string, unknown>;
  
}

export const generateD3Path = <T>({
  x_key,
  y_key,
  scale_x, 
  scale_y, 
  curve,
}: D3LineProps,
  data?: Partial<T>[],
): string | undefined => {
  
  if (curve === 'step') curve = curveStep
  else if (curve === 'step-after') curve = curveStepAfter
  else if (curve === 'step-before') curve = curveStepBefore

  const {
    scale: x_scale,
 
    scale_type: x_type
  } = scale_x || {}

  x_key = x_key || scale_x?.key
  y_key = y_key || scale_y?.key
  const {
    scale: y_scale,
 
 
    scale_type: y_type
  } = scale_y || {}

  if (typeof x_scale !== 'function' || typeof y_scale !== 'function' || !data) return

  const lineBuilder = line()
    .x((d) =>  {
      let x_val = (d as T)?.[x_key as keyof T] as string | number | Date
      if (x_type === 'time') x_val = new Date(x_val).getTime()
      if (x_type === 'linear') x_val = Number(x_val)
      return x_scale?.(x_val) as number
    })
    .y((d) => {
      let y_val = (d as T)?.[y_key as keyof T] as string | number | Date
      if (y_type === 'time') y_val = new Date(y_val).getTime()
      if (y_type === 'linear') y_val = Number(y_val)
      return y_scale?.(y_val) as number
    }) 

    if (typeof curve === 'function') lineBuilder.curve(curve)

    return lineBuilder((data || []) as Partial<T>[] & [number, number][]) || undefined

  }